function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import n20ActionButtonMixin from './n20ActionButtonMixin';
export default {
  name: 'CoreN20Card',
  mixins: [n20ActionButtonMixin],
  inheritAttrs: false,
  props: {
    border: {
      type: String,
      "default": ''
    },
    inline: {
      type: Boolean,
      "default": false
    },
    fullWidth: {
      type: Boolean,
      "default": false
    },
    offset: {
      type: [Number, String],
      "default": 40
    },
    icon: {
      type: String,
      "default": ''
    },
    title: {
      type: String,
      "default": ''
    },
    note: {
      type: String,
      "default": ''
    }
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])), {}, {
    hasOffset: function hasOffset() {
      return this.hasButtons || !!this.$slots.buttons || !!this.title || !!this.icon || !!this.note;
    },
    styles: function styles() {
      if (!this.hasOffset) {
        return null;
      }
      return {
        marginTop: "".concat(parseInt(this.offset) * 2 + 2, "px")
      };
    },
    cloading: function cloading() {
      return this.$store.state.app.loading;
    },
    cardStyles: function cardStyles() {
      if (!this.hasButtons && !this.$slots.buttons) {
        return {
          'max-width': "calc(100% - ".concat(24, "px)")
        };
      } else {
        var width = 50;
        this.buttons.forEach(function (button) {
          if (button.title) {
            width += button.title.length * 7 + 80;
          } else {
            width += 50;
          }
        });
        if (width > 400) {
          return {
            display: 'none'
          };
        }
        return {
          'max-width': "calc(100% - ".concat(width, "px)")
        };
      }
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }),
  methods: {
    borderStyle: function borderStyle() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'border';
      if (this.border) {
        return "".concat(item, ": ").concat(this.border);
      }
      return '';
    }
  }
};